var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25065 39.5833V11.875C6.25052 11.4473 6.38201 11.03 6.62725 10.6796C6.8725 10.3293 7.21962 10.0629 7.62148 9.91662L27.7694 2.59162C27.9268 2.53434 28.0957 2.51586 28.2617 2.53773C28.4278 2.55961 28.5861 2.6212 28.7233 2.71729C28.8604 2.81338 28.9724 2.94112 29.0497 3.0897C29.127 3.23828 29.1674 3.4033 29.1673 3.57079V13.8895L42.3257 18.275C42.7407 18.4132 43.1016 18.6785 43.3574 19.0334C43.6132 19.3882 43.7508 19.8146 43.7507 20.252V39.5833H47.9173V43.75H2.08398V39.5833H6.25065ZM10.4173 39.5833H25.0007V8.0312L10.4173 13.3354V39.5833ZM39.584 39.5833V21.7541L29.1673 18.2812V39.5833H39.584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.ad405fcbe2d07927dfd66c19af9abb14.svg";
export { ForwardRef as ReactComponent };